// extracted by mini-css-extract-plugin
module.exports = {"container":"TxBoxView_container__2DACD","transparent":"TxBoxView_transparent__2AJ7T"};